/*
 * Seletor de variantes do produto.
 *
 * Comportamento vindo do Dawn, reescrito: ao trocar uma opcao, encontra a
 * variante correspondente, atualiza o preco, o botao, o endereco da
 * pagina e o campo escondido que vai para o carrinho.
 *
 * O elemento espera dentro de si:
 *   <script type="application/json" data-variantes>[...]</script>
 *   um ou mais [name="options[...]"]
 *   <input name="id"> escondido
 *
 * Fica pronto aqui na Etapa 3 e entra em uso na pagina de produto.
 */

class ArtisanVariantes extends HTMLElement {
  connectedCallback() {
    const dados = this.querySelector('[data-variantes]');
    if (!dados) return;

    try {
      this.variantes = JSON.parse(dados.textContent);
    } catch (erro) {
      console.error('Lista de variantes inválida', erro);
      return;
    }

    this.campoId = this.querySelector('input[name="id"]');
    this.addEventListener('change', () => this.trocar());
  }

  /* As opcoes escolhidas agora, na ordem em que o produto as declara. */
  escolhidas() {
    return Array.from(this.querySelectorAll('[name^="options["]'))
      .filter((campo) => campo.type !== 'radio' || campo.checked)
      .map((campo) => campo.value);
  }

  encontrar(opcoes) {
    return this.variantes.find((variante) =>
      variante.options.every((opcao, i) => opcao === opcoes[i])
    );
  }

  trocar() {
    const variante = this.encontrar(this.escolhidas());

    this.atualizarBotao(variante);
    this.atualizarPreco(variante);
    this.atualizarFoto(variante);

    if (!variante) return;

    if (this.campoId) this.campoId.value = variante.id;

    // Troca o endereco sem recarregar, para o link copiado ja abrir na
    // variante certa.
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variante.id);
    window.history.replaceState({}, '', url);

    this.dispatchEvent(
      new CustomEvent('artisan:variante-mudou', { bubbles: true, detail: { variante } })
    );
  }

  atualizarBotao(variante) {
    const botao = this.querySelector('[data-adicionar]');
    if (!botao) return;

    if (!variante) {
      botao.disabled = true;
      botao.textContent = 'Indisponível';
    } else if (!variante.available) {
      botao.disabled = true;
      botao.textContent = 'Esgotado';
    } else {
      botao.disabled = false;
      botao.textContent = botao.dataset.textoPadrao || 'Quero esse';
    }
  }

  atualizarPreco(variante) {
    const alvo = this.querySelector('[data-preco]');
    if (!alvo || !variante) return;

    alvo.innerHTML = variante.price_html || alvo.innerHTML;
  }

  atualizarFoto(variante) {
    if (!variante || !variante.featured_media_id) return;

    const galeria = document.querySelector('[data-galeria-produto]');
    if (!galeria) return;

    const foto = galeria.querySelector(`[data-media-id="${variante.featured_media_id}"]`);
    if (foto && typeof foto.scrollIntoView === 'function') {
      foto.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }
}

customElements.define('artisan-variantes', ArtisanVariantes);

/* ---------------------------------------------------------------
   Galeria do produto: a miniatura empurra o palco, e o palco avisa
   qual miniatura acender. O arrastar no celular e nativo, do
   scroll-snap — aqui so sincronizamos os dois lados.
   --------------------------------------------------------------- */
(function () {
  const galeria = document.querySelector('[data-galeria-produto]');
  if (!galeria) return;

  const palco = galeria.querySelector('[data-palco]');
  const minis = Array.from(galeria.querySelectorAll('[data-mini]'));
  if (!palco || minis.length === 0) return;

  const slides = Array.from(palco.querySelectorAll('[data-slide]'));

  function acender(i) {
    minis.forEach((m, n) => {
      const ativa = n === i;
      m.classList.toggle('is-ativa', ativa);
      m.setAttribute('aria-selected', ativa ? 'true' : 'false');
    });
  }

  minis.forEach((mini, i) => {
    mini.addEventListener('click', () => {
      const alvo = slides[i];
      if (!alvo) return;
      palco.scrollTo({ left: alvo.offsetLeft - palco.offsetLeft, behavior: 'smooth' });
      acender(i);
    });
  });

  /* Qual slide esta na frente depois do arrastar. O IntersectionObserver
     evita ficar ouvindo cada quadro do scroll. */
  if ('IntersectionObserver' in window) {
    const olho = new IntersectionObserver(
      (entradas) => {
        entradas.forEach((e) => {
          if (e.isIntersecting) acender(slides.indexOf(e.target));
        });
      },
      { root: palco, threshold: 0.6 }
    );
    slides.forEach((s) => olho.observe(s));
  }
})();

